/* Which dashboard a person sees -- shared by the Dashboard page, the app header's title and Team → Edit
   user. The Dashboard by group (Duncan 2026-10-20: "The Accounting dashboard should look different than a
   project manager's dashboard, which will look different than vice president of construction").
   Each role has a default (Accounting → Accounting; everyone else → Projects, as today), and a person
   can be set to a specific one in Team → Edit user → Dashboard ("there's a default one for a user
   group, but when you go into edit user, you can change the dashboard"; users.dashboard, NULL = the
   role's). An admin also switches between them with ?view=. More dashboards join as they're built. */
export const DASHBOARD_OPTIONS = [{ value: 'projects', label: 'Projects' }, { value: 'accounting', label: 'Accounting' }];
const KNOWN = DASHBOARD_OPTIONS.map((o) => o.value);
const ROLE_DEFAULT = { accounting: 'accounting' };
export const defaultDashboardFor = (role) => ROLE_DEFAULT[role] || 'projects';
export const dashboardLabel = (v) => (DASHBOARD_OPTIONS.find((o) => o.value === v) || DASHBOARD_OPTIONS[0]).label;
export const dashboardViewOf = (user, params) => {
  const asked = params && params.get('view');
  if (user && user.role === 'admin' && KNOWN.includes(asked)) return asked;
  if (user && KNOWN.includes(user.dashboard)) return user.dashboard;
  return defaultDashboardFor(user && user.role);
};
